import type { PropsWithChildren } from 'react';

import { ErrorMessage } from './components/ErrorMessage';
import { LoadingSkeleton } from './components/LoadingSkeleton';
import { NoResultsScreen } from './components/NoResultsScreen';
import { useSearchResultList } from './hooks/useSearchResultList';

export const SearchResultList: React.FC<PropsWithChildren> = ({ children }) => {
	const {
		data: { isLoading, isError, isEmptyResults },
	} = useSearchResultList();

	// This render logic is necessary to avoid the infinite loop when rendering a conditional loading component with children.
	// https://github.com/algolia/instantsearch/issues/5269
	return (
		<>
			{isError && <ErrorMessage />}
			{isLoading && <LoadingSkeleton />}
			{isEmptyResults && <NoResultsScreen />}
			<div className={isLoading || isError || isEmptyResults ? 'hidden' : 'block'}>{children}</div>
		</>
	);
};
